import { useMemo } from "react";
import Actions from "../../components/modals/Actions";
import { useVisible } from "../../../../../utils/hooks/useVisible";

export const useActionsModal = () => {
    const { visible, open, close, selected } = useVisible();

    const modal = useMemo(() => {
        return (
            <Actions
                values={selected}
                visible={visible}
                close={close}
            />
        );
    }, [selected, visible, close]);

    return { open, modal };
}